<template>
  <div class="center-div">
    <a-row class="justify-center">
      <a-col :span="7">
        <div class="mt-4" style="text-align:center">
          <h4 class="text-bold">Let's Verify your Email Address</h4>
          <span class="text-opacity">📨 We just shot a mail to you.</span>
        </div>
        <a-card class="mt-4">
          <a-form :form="form">
            <a-form-item class="form-input">
              <center>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="140.395"
                  height="110.468"
                  viewBox="0 0 240.395 210.468"
                >
                  <g id="Group_1" data-name="Group 1" transform="translate(-1399 -1373.433)">
                    <path
                      id="iconmonstr-paper-plane-7"
                      d="M158.233,0,126.072,105.807,82.5,70.987l41.824-39.6L68.26,66.152,29.588,57.713ZM79.616,80.164v35.263L95.29,94.117ZM17.452,123.929,7.168,120.678,47.913,87.237l10.263,2.539ZM40.766,151.42,31.31,147.8l31.725-28.876,9.434,2.918-31.7,29.581ZM11.585,153.9,1,150.651l57.176-50.6,10.27,2.546L11.585,153.9Z"
                      transform="translate(1398 1430)"
                      fill="#3726bf"
                    ></path>
                    <path
                      id="ic_star_24px"
                      d="M17.225,23.638l9.409,5.286-2.5-9.962,8.313-6.7L21.5,11.4,17.225,2l-4.278,9.4L2,12.259l8.313,6.7-2.5,9.962Z"
                      transform="translate(1489.278 1396.842) rotate(-9)"
                      fill="#919a23"
                    ></path>
                    <path
                      id="ic_star_24px-2"
                      data-name="ic_star_24px"
                      d="M17.225,23.638l9.409,5.286-2.5-9.962,8.313-6.7L21.5,11.4,17.225,2l-4.278,9.4L2,12.259l8.313,6.7-2.5,9.962Z"
                      transform="translate(1565.034 1414.365) rotate(2)"
                      fill="#919a23"
                    ></path>
                    <path
                      id="ic_star_24px-3"
                      data-name="ic_star_24px"
                      d="M17.225,23.638l9.409,5.286-2.5-9.962,8.313-6.7L21.5,11.4,17.225,2l-4.278,9.4L2,12.259l8.313,6.7-2.5,9.962Z"
                      transform="translate(1540.034 1371.365) rotate(2)"
                      fill="#919a23"
                    ></path>
                    <path
                      id="ic_star_24px-4"
                      data-name="ic_star_24px"
                      d="M17.225,23.638l9.409,5.286-2.5-9.962,8.313-6.7L21.5,11.4,17.225,2l-4.278,9.4L2,12.259l8.313,6.7-2.5,9.962Z"
                      transform="translate(1607.034 1395.365) rotate(2)"
                      fill="#919a23"
                    ></path>
                    <path
                      id="ic_star_24px-5"
                      data-name="ic_star_24px"
                      d="M17.225,23.638l9.409,5.286-2.5-9.962,8.313-6.7L21.5,11.4,17.225,2l-4.278,9.4L2,12.259l8.313,6.7-2.5,9.962Z"
                      transform="translate(1581.034 1455.365) rotate(2)"
                      fill="#919a23"
                    ></path>
                  </g>
                </svg>
              </center>
            </a-form-item>
            <a-form-item>
              <div style="line-height:25px; text-align:left">
                An email was just sent to the address:
                <span
                  class="text-bold"
                >obodugorapheal@gmail.com</span> to help verify your Email Address.
                Please Click on the link sent on the mail to verify your email address.
              </div>
            </a-form-item>
            <span class="text-opacity">
              Already a user?,
              <b class="text-purple">Sign in</b> to your Account
            </span>
          </a-form>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<style scoped>
.btn-primary {
  width: 100%;
  height: 40px;
  padding-top: 0px !important;
}
</style>

<script>
import "@/assets/css/auth.scss";
export default {
  data() {
    return {};
  }
};
</script>

